import React from 'react';
import { ForgeTab, ForgeTabBar, ForgeTooltip } from '@tylertech/forge-react';
import { ITabBarChangeEventData } from '@tylertech/forge';

import { Hierarchy } from 'common/visualizations/vif';
import { getHierarchyHeaderText } from 'common/authoring_workflow/components/panes/DataPane/TableHierarchyGroupings/components/TableHierarchyGroupingHeader';
import { ViewColumn } from 'common/types/viewColumn';
import './index.scss';

export interface HierarchyTabsProps {
  activeHierarchyId?: string;
  onTabChange: (newTabId: string) => void;
  hierarchies: Hierarchy[];
  columns: ViewColumn[];
}

const DISPLAY_HIERARCHY_TABS_THRESHOLD = 2;

const HierarchyTabs = (props: HierarchyTabsProps): JSX.Element => {
  const { hierarchies, activeHierarchyId, onTabChange, columns } = props;

  if (hierarchies.length < DISPLAY_HIERARCHY_TABS_THRESHOLD) {
    return <div data-testid="empty-hierarchy"></div>;
  }

  const onTabClick = (index: number) => {
    const newActiveHierarcyId: string = hierarchies[index].id;
    onTabChange(newActiveHierarcyId);
  };

  const activeHierarchyIndex = hierarchies.findIndex((h: Hierarchy) => h.id === activeHierarchyId);

  return (
    <div className="hierarchy-tab-container">
      <ForgeTabBar
        underline
        layoutMode="clustered"
        activeTab={activeHierarchyIndex}
        on-forge-tab-bar-change={(event: CustomEvent<ITabBarChangeEventData>) =>
          onTabClick(event.detail.index)
        }
      >
        {hierarchies.map((hierarchy) => {
          const groupingColumns = (hierarchy.columnConfigurations ?? []).filter((h) => h.isGrouping);
          const name = hierarchy.name || getHierarchyHeaderText(groupingColumns, columns);
          return (
            <ForgeTab
              active={hierarchy.id === activeHierarchyId}
              data-testid={`hierarchy-tab-${hierarchy.id}`}
              key={hierarchy.id}
            >
              <span className="hierarchy-tab-title">{name}</span>
              <ForgeTooltip placement="bottom">
                <div className="tooltip-content">{name}</div>
              </ForgeTooltip>
            </ForgeTab>
          );
        })}
      </ForgeTabBar>
    </div>
  );
};

export default HierarchyTabs;
